import React from 'react';
import Modal from '@components/ui/Modal';
import QuoteForm from './QuoteForm';
import type { QuoteFormData } from '../../types/quote.types';

interface QuoteModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const QuoteModal: React.FC<QuoteModalProps> = ({ isOpen, onClose }) => {
  const handleSubmit = (data: QuoteFormData) => {
    console.log('Quote Request:', data);
    alert('Thank you for your quote request! We will contact you within 24 hours.');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Request a Quote">
      <QuoteForm onSubmit={handleSubmit} onCancel={onClose} />
    </Modal>
  );
};

export default QuoteModal;